const isLocal = window.location.hostname === "localhost";
const appOrigin = window.location.origin;

export const msalConfig = {
  auth: {
    clientId: "b6d14e0f-c0bb-48fe-8d1d-49de0638691c",
    authority: "https://login.microsoftonline.com/c6ea57e8-5519-4e8d-9e5d-98e28769942f",
    redirectUri: appOrigin,
    postLogoutRedirectUri: appOrigin
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: [
    "User.Read",
    "api://b6d14e0f-c0bb-48fe-8d1d-49de0638691c/access_as_user"
  ],
};

export const API_BASE_URL = isLocal
  ? "http://localhost:7071/api"
  : "https://ic-travel-request-api.azurewebsites.net/api";

export const getApiToken = async (msalInstance) => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null;
  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: ["api://b6d14e0f-c0bb-48fe-8d1d-49de0638691c/access_as_user"],
      account: accounts[0]
    });
    return response.accessToken;
  } catch (e) {
    try {
      const response = await msalInstance.acquireTokenPopup({
        scopes: ["api://b6d14e0f-c0bb-48fe-8d1d-49de0638691c/access_as_user"],
        account: accounts[0]
      });
      return response.accessToken;
    } catch (e2) {
      console.error("Failed to acquire token:", e2);
      return null;
    }
  }
};